module.exports = __webpack_public_path__ + "img/DZ.8563fb78.png";